// The app's version as testers see it (docs/specs/settings.md DI-3): the version from
// apps/app/package.json and the commit it was built from, `0.1.0+4955ef3`, as Android's version
// name. Set at build time by vite.config.ts; `dev` where no build set it (the unit tests).

declare const __CASA_VERSION__: string | undefined;
/** The build number that orders releases (app-updates AU-10); 0 where it could not be counted. */
declare const __CASA_BUILD__: number | undefined;

export const appVersion: string = typeof __CASA_VERSION__ === 'string' ? __CASA_VERSION__ : 'dev';

export const appBuild: number = typeof __CASA_BUILD__ === 'number' ? __CASA_BUILD__ : 0;
